import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReactFlowProvider } from 'reactflow';
import useStore from '../store/useStore';
import Toolbar from '../components/Toolbar';
import Canvas from '../components/Canvas';
import Sidebar from '../components/Sidebar';
import { useT } from '../i18n';

export default function AdminViewerPage() {
  const t = useT();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useStore((s) => s.theme);
  const accessToken = useStore((s) => s.accessToken);
  const userEmail = useStore((s) => s.userEmail);
  const restoreFromJSON = useStore((s) => s.restoreFromJSON);
  const resetEditor = useStore((s) => s.resetEditor);
  const setReadOnly = useStore((s) => s.setReadOnly);
  const selectedNodeId = useStore((s) => s.selectedNodeId);
  const [menuCollapsed, setMenuCollapsed] = useState(() => {
    return localStorage.getItem('editorSidebar') === 'closed';
  });

  const toggleMenu = () => {
    const next = !menuCollapsed;
    setMenuCollapsed(next);
    localStorage.setItem('editorSidebar', next ? 'closed' : 'open');
  };

  const projectJson = location.state?.projectJson;
  const projectName = location.state?.projectName;

  useEffect(() => {
    if (!accessToken) { navigate('/'); return; }
    if (userEmail && userEmail !== 'davronking001@gmail.com') { navigate('/home'); return; }
    if (!projectJson) { navigate('/admin'); return; }

    try {
      const parsed = JSON.parse(projectJson);
      restoreFromJSON(parsed);
      setReadOnly(true);
    } catch {
      navigate('/admin');
    }

    return () => {
      setReadOnly(false);
      resetEditor();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!projectJson) return null;

  return (
    <ReactFlowProvider>
      <div className={`app ${theme}`}>
        <div className="main-layout">
          <Toolbar collapsed={menuCollapsed} onToggle={toggleMenu} />
          <div className="main-area">
            <Canvas />
            <Sidebar />
          </div>
        </div>

        <div className="admin-view-banner">
          <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M1.5 9s2.5-5 7.5-5 7.5 5 7.5 5-2.5 5-7.5 5S1.5 9 1.5 9z" />
            <circle cx="9" cy="9" r="2.5" />
          </svg>
          <span>{t('admin.viewingBadge')}{projectName ? ` — ${projectName}` : ''}</span>
        </div>

        <button
          className={`back-to-home ${selectedNodeId ? 'sidebar-open' : ''}`}
          onClick={() => navigate('/admin')}
          title={t('admin.backToPanel')}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M12 8H4M4 8l4-4M4 8l4 4" />
          </svg>
        </button>
      </div>
    </ReactFlowProvider>
  );
}
